<div class="card">
    <div class="card-body">
        <h4 class="card-title">Editar preguntas Terman</h4>
        
        <div class="m-t-40">
                <div class="d-flex">

                </div>
            </div>

        <h3 class="m-b-10 m-t-10">SERIE I</h3>
        <table  class="table table-bordered table-hover toggle-circle " >
            <thead>
                <tr>
                    <th>#</th>
                    <th data-toggle="true" class="footable-visible footable-first-column footable-sortable footable-sorted">Titulo<span class="footable-sort-indicator"></span></th>
                    <th data-toggle="true" class="footable-visible footable-first-column footable-sortable footable-sorted">Serie<span class="footable-sort-indicator"></span></th>
                    <th class="min-width footable-visible footable-last-column text-center">Ver/Editar</th>
                </tr>
            </thead>
            
            <tbody>
                <tr *ngFor="let question of questions1">
                    <td>{{question.index}}</td>
                    <td *ngIf="(question.serie!=3)&&(question.serie!=9)" class="footable-visible footable-first-column"><span class="footable-toggle"></span>{{question.title}}</td>
                    <td *ngIf="question.serie==3" class="footable-visible footable-first-column"><span class="footable-toggle"></span>{{question.pair.text}}</td>
                    <td *ngIf="question.serie==9" class="footable-visible footable-first-column"><span class="footable-toggle"></span>{{question.opcA.text}} - {{question.opcB.text}} - {{question.opcC.text}} - {{question.opcD.text}} - {{question.opcE.text}}</td>


                    <td class="footable-visible footable-first-column"><span class="footable-toggle"></span>{{question.serie}}</td>

                    <td class="footable-visible footable-last-column text-center">
                        <button type="button" class="btn btn-sm btn-icon btn-pure btn-outline " data-toggle="modal" data-target="#myModal" (click)="handleEdit(question._id)" ><i class="fa fa-pencil" aria-hidden="true"></i></button>
                        <button type="button" class="btn btn-sm btn-icon btn-pure btn-outline " (click)="handleDelete(question._id)" ><i class="fa fa-eraser" ></i></button>
                    
                    </td>
                </tr>
            </tbody>
     
        </table>

        <h3 class="m-b-10 m-t-10">SERIE II</h3>

        <table  class="table table-bordered table-hover toggle-circle " >
            <thead>
                <tr>
                    <th>#</th>
                    <th data-toggle="true" class="footable-visible footable-first-column footable-sortable footable-sorted">Titulo<span class="footable-sort-indicator"></span></th>
                    <th data-toggle="true" class="footable-visible footable-first-column footable-sortable footable-sorted">Serie<span class="footable-sort-indicator"></span></th>
                    <th class="min-width footable-visible footable-last-column text-center">Ver/Editar</th>
                </tr>
            </thead>
            
            <tbody>
                <tr *ngFor="let question of questions2">
                    <td>{{question.index}}</td>
                    <td *ngIf="(question.serie!=3)&&(question.serie!=9)" class="footable-visible footable-first-column"><span class="footable-toggle"></span>{{question.title}}</td>
                    <td *ngIf="question.serie==3" class="footable-visible footable-first-column"><span class="footable-toggle"></span>{{question.pair.text}}</td>
                    <td *ngIf="question.serie==9" class="footable-visible footable-first-column"><span class="footable-toggle"></span>{{question.opcA.text}} - {{question.opcB.text}} - {{question.opcC.text}} - {{question.opcD.text}} - {{question.opcE.text}}</td>


                    <td class="footable-visible footable-first-column"><span class="footable-toggle"></span>{{question.serie}}</td>

                    <td class="footable-visible footable-last-column text-center">
                        <button type="button" class="btn btn-sm btn-icon btn-pure btn-outline " data-toggle="modal" data-target="#myModal" (click)="handleEdit(question._id)" ><i class="fa fa-pencil" aria-hidden="true"></i></button>
                        <button type="button" class="btn btn-sm btn-icon btn-pure btn-outline " (click)="handleDelete(question._id)" ><i class="fa fa-eraser" ></i></button>
                    
                    </td>
                </tr>
            </tbody>
     
        </table>
        <h3 class="m-b-10 m-t-10">SERIE III</h3>

        <table  class="table table-bordered table-hover toggle-circle " >
            <thead>
                <tr>
                    <th>#</th>
                    <th data-toggle="true" class="footable-visible footable-first-column footable-sortable footable-sorted">Titulo<span class="footable-sort-indicator"></span></th>
                    <th data-toggle="true" class="footable-visible footable-first-column footable-sortable footable-sorted">Serie<span class="footable-sort-indicator"></span></th>
                    <th class="min-width footable-visible footable-last-column text-center">Ver/Editar</th>
                </tr>
            </thead>
            
            <tbody>
                <tr *ngFor="let question of questions3">
                    <td>{{question.index}}</td>

                    <td *ngIf="(question.serie!=3)&&(question.serie!=9)" class="footable-visible footable-first-column"><span class="footable-toggle"></span>{{question.title}}</td>
                    <td *ngIf="question.serie==3" class="footable-visible footable-first-column"><span class="footable-toggle"></span>{{question.pair.text}}</td>
                    <td *ngIf="question.serie==9" class="footable-visible footable-first-column"><span class="footable-toggle"></span>{{question.opcA.text}} - {{question.opcB.text}} - {{question.opcC.text}} - {{question.opcD.text}} - {{question.opcE.text}}</td>


                    <td class="footable-visible footable-first-column"><span class="footable-toggle"></span>{{question.serie}}</td>

                    <td class="footable-visible footable-last-column text-center">
                        <button type="button" class="btn btn-sm btn-icon btn-pure btn-outline " data-toggle="modal" data-target="#myModal" (click)="handleEdit(question._id)" ><i class="fa fa-pencil" aria-hidden="true"></i></button>
                        <button type="button" class="btn btn-sm btn-icon btn-pure btn-outline " (click)="handleDelete(question._id)" ><i class="fa fa-eraser" ></i></button>
                    
                    </td>
                </tr>
            </tbody>
     
        </table>
        <h3 class="m-b-10 m-t-10">SERIE IV</h3>

        <table  class="table table-bordered table-hover toggle-circle " >
            <thead>
                <tr>
                    <th>#</th>
                    <th data-toggle="true" class="footable-visible footable-first-column footable-sortable footable-sorted">Titulo<span class="footable-sort-indicator"></span></th>
                    <th data-toggle="true" class="footable-visible footable-first-column footable-sortable footable-sorted">Serie<span class="footable-sort-indicator"></span></th>
                    <th class="min-width footable-visible footable-last-column text-center">Ver/Editar</th>
                </tr>
            </thead>
            
            <tbody>
                <tr *ngFor="let question of questions4">
                    <td>{{question.index}}</td>

                    <td *ngIf="(question.serie!=3)&&(question.serie!=9)" class="footable-visible footable-first-column"><span class="footable-toggle"></span>{{question.title}}</td>
                    <td *ngIf="question.serie==3" class="footable-visible footable-first-column"><span class="footable-toggle"></span>{{question.pair.text}}</td>
                    <td *ngIf="question.serie==9" class="footable-visible footable-first-column"><span class="footable-toggle"></span>{{question.opcA.text}} - {{question.opcB.text}} - {{question.opcC.text}} - {{question.opcD.text}} - {{question.opcE.text}}</td>


                    <td class="footable-visible footable-first-column"><span class="footable-toggle"></span>{{question.serie}}</td>

                    <td class="footable-visible footable-last-column text-center">
                        <button type="button" class="btn btn-sm btn-icon btn-pure btn-outline " data-toggle="modal" data-target="#myModal" (click)="handleEdit(question._id)" ><i class="fa fa-pencil" aria-hidden="true"></i></button>
                        <button type="button" class="btn btn-sm btn-icon btn-pure btn-outline " (click)="handleDelete(question._id)" ><i class="fa fa-eraser" ></i></button>
                    
                    </td>
                </tr>
            </tbody>
     
        </table>
        <h3 class="m-b-10 m-t-10">SERIE V</h3>

        <table  class="table table-bordered table-hover toggle-circle " >
            <thead>
                <tr>
                    <th>#</th>
                    <th data-toggle="true" class="footable-visible footable-first-column footable-sortable footable-sorted">Titulo<span class="footable-sort-indicator"></span></th>
                    <th data-toggle="true" class="footable-visible footable-first-column footable-sortable footable-sorted">Serie<span class="footable-sort-indicator"></span></th>
                    <th class="min-width footable-visible footable-last-column text-center">Ver/Editar</th>
                </tr>
            </thead>
            
            <tbody>
                <tr *ngFor="let question of questions5">
                    <td>{{question.index}}</td>

                    <td *ngIf="(question.serie!=3)&&(question.serie!=9)" class="footable-visible footable-first-column"><span class="footable-toggle"></span>{{question.title}}</td>
                    <td *ngIf="question.serie==3" class="footable-visible footable-first-column"><span class="footable-toggle"></span>{{question.pair.text}}</td>
                    <td *ngIf="question.serie==9" class="footable-visible footable-first-column"><span class="footable-toggle"></span>{{question.opcA.text}} - {{question.opcB.text}} - {{question.opcC.text}} - {{question.opcD.text}} - {{question.opcE.text}}</td>


                    <td class="footable-visible footable-first-column"><span class="footable-toggle"></span>{{question.serie}}</td>

                    <td class="footable-visible footable-last-column text-center">
                        <button type="button" class="btn btn-sm btn-icon btn-pure btn-outline " data-toggle="modal" data-target="#myModal" (click)="handleEdit(question._id)" ><i class="fa fa-pencil" aria-hidden="true"></i></button>
                        <button type="button" class="btn btn-sm btn-icon btn-pure btn-outline " (click)="handleDelete(question._id)" ><i class="fa fa-eraser" ></i></button>
                    
                    </td>
                </tr>
            </tbody>
     
        </table>
        <h3 class="m-b-10 m-t-10">SERIE VI</h3>

        <table  class="table table-bordered table-hover toggle-circle " >
            <thead>
                <tr>
                    <th>#</th>
                    <th data-toggle="true" class="footable-visible footable-first-column footable-sortable footable-sorted">Titulo<span class="footable-sort-indicator"></span></th>
                    <th data-toggle="true" class="footable-visible footable-first-column footable-sortable footable-sorted">Serie<span class="footable-sort-indicator"></span></th>
                    <th class="min-width footable-visible footable-last-column text-center">Ver/Editar</th>
                </tr>
            </thead>
            
            <tbody>
                <tr *ngFor="let question of questions6">
                    <td>{{question.index}}</td>

                    <td *ngIf="(question.serie!=3)&&(question.serie!=9)" class="footable-visible footable-first-column"><span class="footable-toggle"></span>{{question.title}}</td>
                    <td *ngIf="question.serie==3" class="footable-visible footable-first-column"><span class="footable-toggle"></span>{{question.pair.text}}</td>
                    <td *ngIf="question.serie==9" class="footable-visible footable-first-column"><span class="footable-toggle"></span>{{question.opcA.text}} - {{question.opcB.text}} - {{question.opcC.text}} - {{question.opcD.text}} - {{question.opcE.text}}</td>


                    <td class="footable-visible footable-first-column"><span class="footable-toggle"></span>{{question.serie}}</td>

                    <td class="footable-visible footable-last-column text-center">
                        <button type="button" class="btn btn-sm btn-icon btn-pure btn-outline " data-toggle="modal" data-target="#myModal" (click)="handleEdit(question._id)" ><i class="fa fa-pencil" aria-hidden="true"></i></button>
                        <button type="button" class="btn btn-sm btn-icon btn-pure btn-outline " (click)="handleDelete(question._id)" ><i class="fa fa-eraser" ></i></button>
                    
                    </td>
                </tr>
            </tbody>
     
        </table>
        <h3 class="m-b-10 m-t-10">SERIE VII</h3>

        <table  class="table table-bordered table-hover toggle-circle " >
            <thead>
                <tr>
                    <th>#</th>
                    <th data-toggle="true" class="footable-visible footable-first-column footable-sortable footable-sorted">Titulo<span class="footable-sort-indicator"></span></th>
                    <th data-toggle="true" class="footable-visible footable-first-column footable-sortable footable-sorted">Serie<span class="footable-sort-indicator"></span></th>
                    <th class="min-width footable-visible footable-last-column text-center">Ver/Editar</th>
                </tr>
            </thead>
            
            <tbody>
                <tr *ngFor="let question of questions7">
                    <td>{{question.index}}</td>
                    <td *ngIf="(question.serie!=3)&&(question.serie!=9)" class="footable-visible footable-first-column"><span class="footable-toggle"></span>{{question.title}}</td>
                    <td *ngIf="question.serie==3" class="footable-visible footable-first-column"><span class="footable-toggle"></span>{{question.pair.text}}</td>
                    <td *ngIf="question.serie==9" class="footable-visible footable-first-column"><span class="footable-toggle"></span>{{question.opcA.text}} - {{question.opcB.text}} - {{question.opcC.text}} - {{question.opcD.text}} - {{question.opcE.text}}</td>


                    <td class="footable-visible footable-first-column"><span class="footable-toggle"></span>{{question.serie}}</td>

                    <td class="footable-visible footable-last-column text-center">
                        <button type="button" class="btn btn-sm btn-icon btn-pure btn-outline " data-toggle="modal" data-target="#myModal" (click)="handleEdit(question._id)" ><i class="fa fa-pencil" aria-hidden="true"></i></button>
                        <button type="button" class="btn btn-sm btn-icon btn-pure btn-outline " (click)="handleDelete(question._id)" ><i class="fa fa-eraser" ></i></button>
                    
                    </td>
                </tr>
            </tbody>
     
        </table>
        <h3 class="m-b-10 m-t-10">SERIE VIII</h3>

        <table  class="table table-bordered table-hover toggle-circle " >
            <thead>
                <tr>
                    <th>#</th>
                    <th data-toggle="true" class="footable-visible footable-first-column footable-sortable footable-sorted">Titulo<span class="footable-sort-indicator"></span></th>
                    <th data-toggle="true" class="footable-visible footable-first-column footable-sortable footable-sorted">Serie<span class="footable-sort-indicator"></span></th>
                    <th class="min-width footable-visible footable-last-column text-center">Ver/Editar</th>
                </tr>
            </thead>
            
            <tbody>
                <tr *ngFor="let question of questions8">
                    <td>{{question.index}}</td>

                    <td *ngIf="(question.serie!=3)&&(question.serie!=9)" class="footable-visible footable-first-column"><span class="footable-toggle"></span>{{question.title}}</td>
                    <td *ngIf="question.serie==3" class="footable-visible footable-first-column"><span class="footable-toggle"></span>{{question.pair.text}}</td>
                    <td *ngIf="question.serie==9" class="footable-visible footable-first-column"><span class="footable-toggle"></span>{{question.opcA.text}} - {{question.opcB.text}} - {{question.opcC.text}} - {{question.opcD.text}} - {{question.opcE.text}}</td>


                    <td class="footable-visible footable-first-column"><span class="footable-toggle"></span>{{question.serie}}</td>

                    <td class="footable-visible footable-last-column text-center">
                        <button type="button" class="btn btn-sm btn-icon btn-pure btn-outline " data-toggle="modal" data-target="#myModal" (click)="handleEdit(question._id)" ><i class="fa fa-pencil" aria-hidden="true"></i></button>
                        <button type="button" class="btn btn-sm btn-icon btn-pure btn-outline " (click)="handleDelete(question._id)" ><i class="fa fa-eraser" ></i></button>
                    
                    </td>
                </tr>
            </tbody>
     
        </table>
        <h3 class="m-b-10 m-t-10">SERIE IX</h3>

        <table  class="table table-bordered table-hover toggle-circle " >
            <thead>
                <tr>
                    <th>#</th>
                    <th data-toggle="true" class="footable-visible footable-first-column footable-sortable footable-sorted">Titulo<span class="footable-sort-indicator"></span></th>
                    <th data-toggle="true" class="footable-visible footable-first-column footable-sortable footable-sorted">Serie<span class="footable-sort-indicator"></span></th>
                    <th class="min-width footable-visible footable-last-column text-center">Ver/Editar</th>
                </tr>
            </thead>
            
            <tbody>
                <tr *ngFor="let question of questions9">
                    <td>{{question.index}}</td>

                    <td *ngIf="(question.serie!=3)&&(question.serie!=9)" class="footable-visible footable-first-column"><span class="footable-toggle"></span>{{question.title}}</td>
                    <td *ngIf="question.serie==3" class="footable-visible footable-first-column"><span class="footable-toggle"></span>{{question.pair.text}}</td>
                    <td *ngIf="question.serie==9" class="footable-visible footable-first-column"><span class="footable-toggle"></span>{{question.opcA.text}} - {{question.opcB.text}} - {{question.opcC.text}} - {{question.opcD.text}} - {{question.opcE.text}}</td>


                    <td class="footable-visible footable-first-column"><span class="footable-toggle"></span>{{question.serie}}</td>

                    <td class="footable-visible footable-last-column text-center">
                        <button type="button" class="btn btn-sm btn-icon btn-pure btn-outline " data-toggle="modal" data-target="#myModal" (click)="handleEdit(question._id)" ><i class="fa fa-pencil" aria-hidden="true"></i></button>
                        <button type="button" class="btn btn-sm btn-icon btn-pure btn-outline " (click)="handleDelete(question._id)" ><i class="fa fa-eraser" ></i></button>
                    
                    </td>
                </tr>
            </tbody>
     
        </table>
        <h3 class="m-b-10 m-t-10">SERIE X</h3>

        <table  class="table table-bordered table-hover toggle-circle " >
            <thead>
                <tr>
                    <th>#</th>
                    <th data-toggle="true" class="footable-visible footable-first-column footable-sortable footable-sorted">Titulo<span class="footable-sort-indicator"></span></th>
                    <th data-toggle="true" class="footable-visible footable-first-column footable-sortable footable-sorted">Serie<span class="footable-sort-indicator"></span></th>
                    <th class="min-width footable-visible footable-last-column text-center">Ver/Editar</th>
                </tr>
            </thead>
            
            <tbody>
                <tr *ngFor="let question of questions10">
                    <td>{{question.index}}</td>

                    <td *ngIf="(question.serie!=3)&&(question.serie!=9)" class="footable-visible footable-first-column"><span class="footable-toggle"></span>{{question.title}}</td>
                    <td *ngIf="question.serie==3" class="footable-visible footable-first-column"><span class="footable-toggle"></span>{{question.pair.text}}</td>
                    <td *ngIf="question.serie==9" class="footable-visible footable-first-column"><span class="footable-toggle"></span>{{question.opcA.text}} - {{question.opcB.text}} - {{question.opcC.text}} - {{question.opcD.text}} - {{question.opcE.text}}</td>


                    <td class="footable-visible footable-first-column"><span class="footable-toggle"></span>{{question.serie}}</td>

                    <td class="footable-visible footable-last-column text-center">
                        <button type="button" class="btn btn-sm btn-icon btn-pure btn-outline " data-toggle="modal" data-target="#myModal" (click)="handleEdit(question._id)" ><i class="fa fa-pencil" aria-hidden="true"></i></button>
                        <button type="button" class="btn btn-sm btn-icon btn-pure btn-outline " (click)="handleDelete(question._id)" ><i class="fa fa-eraser" ></i></button>
                    
                    </td>
                </tr>
            </tbody>
     
        </table>
    </div>
</div>

<div id="myModal" data-backdrop="static" data-keyboard="false" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" style="display: none;" aria-hidden="true">
    <div class="modal-dialog modal-lg p-20">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title" id="myModalLabel">Terman</h4>
                <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
            </div>
            <div class="card-body">
                <form [formGroup]="termanForm" (ngSubmit)="update()">
                    <div class="row">
                        <div class="col-md-6">
                            <div  >
                                <label class="control-label">Serie</label>
                                <select formControlName="serie" (change)="setSelectedPart($event)" class="form-control custom-select">
                                    <option *ngFor="let n of numbers" [value]="n">Serie {{n}}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="form-body">
                        <div class="row p-t-20">
 
                            <div *ngIf="type=='1'" class="m-t-20">
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label class="control-label">Título</label>
                                        <input formControlName="title" type="text"  class="form-control" placeholder="Título">
                                    </div>
                                </div>
                                <div class="row col-md-12" formGroupName="opcA">
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label class="control-label">Texto opción A</label>
                                            <input formControlName="text" type="text"  class="form-control" placeholder="Texto opción A">
                                        </div>
                                    </div>
                                    <div class="col-md-6">    
                                        <div class="form-group">
                                            <label class="control-label">Valor opción A</label>
                                            <input formControlName="value" type="number"  class="form-control" placeholder="Valor opción A">
                                        </div>
                                    </div>
                                </div>
    
                                <div class="row col-md-12" formGroupName="opcB">
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label class="control-label">Texto opción B</label>
                                            <input formControlName="text" type="text"  class="form-control" placeholder="Texto opción B">
                                        </div>
                                    </div>
                                    <div class="col-md-6">    
                                        <div class="form-group">
                                            <label class="control-label">Valor opción B</label>
                                            <input formControlName="value" type="number"  class="form-control" placeholder="Valor opción B">
                                        </div>
                                    </div>
                                </div>
    
                                <div class="row col-md-12" formGroupName="opcC">
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label class="control-label">Texto opción C</label>
                                            <input formControlName="text" type="text"  class="form-control" placeholder="Texto opción C">
                                        </div>
                                    </div>
                                    <div class="col-md-6">    
                                        <div class="form-group">
                                            <label class="control-label">Valor opción C</label>
                                            <input formControlName="value" type="number"  class="form-control" placeholder="Valor opción C">
                                        </div>
                                    </div>
                                </div>
                                <div class="row col-md-12" formGroupName="opcD">
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label class="control-label">Texto opción D</label>
                                            <input formControlName="text" type="text"  class="form-control" placeholder="Texto opción D">
                                        </div>
                                    </div>
                                    <div class="col-md-6">    
                                        <div class="form-group">
                                            <label class="control-label">Valor opción D</label>
                                            <input formControlName="value" type="number"  class="form-control" placeholder="Valor opción D">
                                        </div>
                                    </div>
                                    
                                </div>

                            </div>
                            <div *ngIf="type=='2'" class="col-12 m-t-20">

                                <div class="form-group">
                                    <label class="control-label">Título</label>
                                    <input formControlName="title" type="text"  class="form-control" placeholder="Título">
                                </div>
 
                                <div class="row col-md-12" formGroupName="opcA">
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label class="control-label">Texto opción A</label>
                                            <input formControlName="text" type="text"  class="form-control" placeholder="Texto opción A">
                                        </div>
                                    </div>
                                    <div class="col-md-6">    
                                        <div class="form-group">
                                            <label class="control-label">Valor opción A</label>
                                            <input formControlName="value" type="number"  class="form-control" placeholder="Valor opción A">
                                        </div>
                                    </div>
                                </div>
    
                                <div class="row col-md-12" formGroupName="opcB">
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label class="control-label">Texto opción B</label>
                                            <input formControlName="text" type="text"  class="form-control" placeholder="Texto opción B">
                                        </div>
                                    </div>
                                    <div class="col-md-6">    
                                        <div class="form-group">
                                            <label class="control-label">Valor opción B</label>
                                            <input formControlName="value" type="number"  class="form-control" placeholder="Valor opción B">
                                        </div>
                                    </div>
                                </div>
    
                                <div class="row col-md-12" formGroupName="opcC">
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label class="control-label">Texto opción C</label>
                                            <input formControlName="text" type="text"  class="form-control" placeholder="Texto opción C">
                                        </div>
                                    </div>
                                    <div class="col-md-6">    
                                        <div class="form-group">
                                            <label class="control-label">Valor opción C</label>
                                            <input formControlName="value" type="number"  class="form-control" placeholder="Valor opción C">
                                        </div>
                                    </div>
                                </div>
                                

                            </div>
                            <div *ngIf="type=='3'" class="col-12 m-t-20">
                                <div class="row col-md-12" formGroupName="pair">
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label class="control-label">Texto</label>
                                            <input formControlName="text" type="text"  class="form-control" placeholder="Texto">
                                        </div>
                                    </div>
                                    <div class="col-md-6">    
                                        <div class="form-group">
                                            <label class="control-label">Valor</label>
                                            <input formControlName="value" type="text"  class="form-control" placeholder="(i)/gual - (o)puesto">
                                        </div>
                                    </div>
                                </div>
                                

                            </div>

                            <div *ngIf="type=='4'" class="m-t-20">
                                <div class="form-group">
                                    <label class="control-label">Título</label>
                                    <input formControlName="title" type="text"  class="form-control" placeholder="Título">
                                </div>
                                <div class="row col-md-12" formGroupName="doubleSelection">
                                    <div class="row col-md-12" formGroupName="opcA">
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label class="control-label">Texto opción A</label>
                                                <input formControlName="text" type="text"  class="form-control" placeholder="Texto opción A">
                                            </div>
                                        </div>
                                        <div class="col-md-6">    
                                            <div class="form-group">
                                                <label class="control-label">Valor opción A</label>
                                                <div class="col-md-12">
                                                    <div class="switch">
                                                        <label><input formControlName="value" type="checkbox" checked=""><span class="lever"></span>Selección</label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
        
                                    <div class="row col-md-12" formGroupName="opcB">
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label class="control-label">Texto opción B</label>
                                                <input formControlName="text" type="text"  class="form-control" placeholder="Texto opción B">
                                            </div>
                                        </div>
                                        <div class="col-md-6">    
                                            <div class="form-group">
                                                <label class="control-label">Valor opción B</label>
                                                <div class="col-md-12">
                                                    <div class="switch">
                                                        <label><input formControlName="value" type="checkbox" checked=""><span class="lever"></span>Selección</label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
        
                                    <div class="row col-md-12" formGroupName="opcC">
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label class="control-label">Texto opción C</label>
                                                <input formControlName="text" type="text"  class="form-control" placeholder="Texto opción C">
                                            </div>
                                        </div>
                                        <div class="col-md-6">    
                                            <div class="form-group">
                                                <label class="control-label">Valor opción C</label>
                                                <div class="col-md-12">
                                                    <div class="switch">
                                                        <label><input formControlName="value" type="checkbox" checked=""><span class="lever"></span>Selección</label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row col-md-12" formGroupName="opcD">
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label class="control-label">Texto opción D</label>
                                                <input formControlName="text" type="text"  class="form-control" placeholder="Texto opción D">
                                            </div>
                                        </div>
                                        <div class="col-md-6">    
                                            <div class="form-group">
                                                <label class="control-label">Valor opción D</label>
                                                <div class="col-md-12">
                                                    <div class="switch">
                                                        <label><input formControlName="value" type="checkbox" checked=""><span class="lever"></span>Selección</label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        
                                    </div>
                                    <div class="row col-md-12" formGroupName="opcE">
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label class="control-label">Texto opción E</label>
                                                <input formControlName="text" type="text"  class="form-control" placeholder="Texto opción E">
                                            </div>
                                        </div>
                                        <div class="col-md-6">    
                                            <div class="form-group">
                                                <label class="control-label">Valor opción E</label>
                                                <div class="col-md-12">
                                                    <div class="switch">
                                                        <label><input formControlName="value" type="checkbox" checked=""><span class="lever"></span>Selección</label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        
                                    </div>
                                </div>
                            </div>

                            <div *ngIf="type=='5'" class="col-12 m-t-20">
                                <div class="form-group">
                                    <label class="control-label">Título</label>
                                    <input formControlName="title" type="text"  class="form-control" placeholder="Título">
                                </div>
                                <div class="row col-md-12" formGroupName="numbers">
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label class="control-label">Valor</label>
                                            <input formControlName="value" type="number"  class="form-control" placeholder="Valor">
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div *ngIf="type=='6'" class="col-12 m-t-20">
                                <div class="form-group">
                                    <label class="control-label">Título</label>
                                    <input formControlName="title" type="text"  class="form-control" placeholder="Título">
                                </div>
                                <div class="row col-md-12" formGroupName="boolean">

                                    <div class="col-md-6">    
                                        <div class="form-group">
                                            <label class="control-label">Valor</label>
                                            <input formControlName="value" type="text"  class="form-control" placeholder="(s)i - (n)o">
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div *ngIf="type=='7'" class="m-t-20">

                                <div class="form-group">
                                    <label class="control-label">Título</label>
                                    <input formControlName="title" type="text"  class="form-control" placeholder="Título">
                                </div>

                                <div class="row col-md-12" formGroupName="opcA">
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label class="control-label">Texto opción A</label>
                                            <input formControlName="text" type="text"  class="form-control" placeholder="Texto opción A">
                                        </div>
                                    </div>
                                    <div class="col-md-6">    
                                        <div class="form-group">
                                            <label class="control-label">Valor opción A</label>
                                            <input formControlName="value" type="number"  class="form-control" placeholder="Valor opción A">
                                        </div>
                                    </div>
                                </div>
    
                                <div class="row col-md-12" formGroupName="opcB">
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label class="control-label">Texto opción B</label>
                                            <input formControlName="text" type="text"  class="form-control" placeholder="Texto opción B">
                                        </div>
                                    </div>
                                    <div class="col-md-6">    
                                        <div class="form-group">
                                            <label class="control-label">Valor opción B</label>
                                            <input formControlName="value" type="number"  class="form-control" placeholder="Valor opción B">
                                        </div>
                                    </div>
                                </div>
    
                                <div class="row col-md-12" formGroupName="opcC">
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label class="control-label">Texto opción C</label>
                                            <input formControlName="text" type="text"  class="form-control" placeholder="Texto opción C">
                                        </div>
                                    </div>
                                    <div class="col-md-6">    
                                        <div class="form-group">
                                            <label class="control-label">Valor opción C</label>
                                            <input formControlName="value" type="number"  class="form-control" placeholder="Valor opción C">
                                        </div>
                                    </div>
                                </div>
                                <div class="row col-md-12" formGroupName="opcD">
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label class="control-label">Texto opción D</label>
                                            <input formControlName="text" type="text"  class="form-control" placeholder="Texto opción D">
                                        </div>
                                    </div>
                                    <div class="col-md-6">    
                                        <div class="form-group">
                                            <label class="control-label">Valor opción D</label>
                                            <input formControlName="value" type="number"  class="form-control" placeholder="Valor opción D">
                                        </div>
                                    </div>
                                    
                                </div>

                            </div>

                            <div *ngIf="type=='8'" class="col-12 m-t-20">
                                <div class="form-group">
                                    <label class="control-label">Título</label>
                                    <input formControlName="title" type="text"  class="form-control" placeholder="Título">
                                </div>
                                <div class="row col-md-12" formGroupName="boolean">
           
                                    <div class="col-md-6">    
                                        <div class="form-group">
                                            <label class="control-label">Valor</label>
                                            <input formControlName="value" type="text"  class="form-control" placeholder="(v)erdader - (f)also">
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div *ngIf="type=='9'" class="m-t-20">

                                <div class="row col-md-12" formGroupName="opcA">
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label class="control-label">Texto opción A</label>
                                            <input formControlName="text" type="text"  class="form-control" placeholder="Texto opción A">
                                        </div>
                                    </div>
                                    <div class="col-md-6">    
                                        <div class="form-group">
                                            <label class="control-label">Valor opción A</label>
                                            <input formControlName="value" type="number"  class="form-control" placeholder="Valor opción A">
                                        </div>
                                    </div>
                                </div>
    
                                <div class="row col-md-12" formGroupName="opcB">
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label class="control-label">Texto opción B</label>
                                            <input formControlName="text" type="text"  class="form-control" placeholder="Texto opción B">
                                        </div>
                                    </div>
                                    <div class="col-md-6">    
                                        <div class="form-group">
                                            <label class="control-label">Valor opción B</label>
                                            <input formControlName="value" type="number"  class="form-control" placeholder="Valor opción B">
                                        </div>
                                    </div>
                                </div>
    
                                <div class="row col-md-12" formGroupName="opcC">
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label class="control-label">Texto opción C</label>
                                            <input formControlName="text" type="text"  class="form-control" placeholder="Texto opción C">
                                        </div>
                                    </div>
                                    <div class="col-md-6">    
                                        <div class="form-group">
                                            <label class="control-label">Valor opción C</label>
                                            <input formControlName="value" type="number"  class="form-control" placeholder="Valor opción C">
                                        </div>
                                    </div>
                                </div>
                                <div class="row col-md-12" formGroupName="opcD">
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label class="control-label">Texto opción D</label>
                                            <input formControlName="text" type="text"  class="form-control" placeholder="Texto opción D">
                                        </div>
                                    </div>
                                    <div class="col-md-6">    
                                        <div class="form-group">
                                            <label class="control-label">Valor opción D</label>
                                            <input formControlName="value" type="number"  class="form-control" placeholder="Valor opción D">
                                        </div>
                                    </div>
                                    
                                </div>
                                <div class="row col-md-12" formGroupName="opcE">
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label class="control-label">Texto opción E</label>
                                            <input formControlName="text" type="text"  class="form-control" placeholder="Texto opción E">
                                        </div>
                                    </div>
                                    <div class="col-md-6">    
                                        <div class="form-group">
                                            <label class="control-label">Valor opción E</label>
                                            <input formControlName="value" type="number"  class="form-control" placeholder="Valor opción E">
                                        </div>
                                    </div>
                                    
                                </div>

                            </div>

                            <div *ngIf="type=='10'" class="col-12 m-t-20">
                                <div class="form-group">
                                    <label class="control-label">Secuencia</label>
                                    <input formControlName="title" type="text"  class="form-control" placeholder="Secuencia">
                                </div>
                                <div class="row col-md-12" formGroupName="textNumbers">
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label class="control-label">Primer valor</label>
                                            <input formControlName="firstValue" type="text"  class="form-control" placeholder="Texto">
                                          
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">

                                            <label class="control-label">Segundo valor</label>
                                            <input formControlName="secondValue" type="text"  class="form-control" placeholder="Texto">
                                        </div>
                                    </div>
                                </div>
                            </div>




                        </div>
                      
                    </div>
                    <div class="col-md-6">    
                        <div class="form-group">
                            <label class="control-label">Ìndice</label>
                            <input formControlName="index" type="number" class="form-control" placeholder="Índice">
                        </div>
                    </div>
                    <div class="form-actions m-t-20">
                        <button type="submit" class="btn btn-success m-r-20"> <i class="fa fa-check"></i> Actualizar</button>
                    </div>
                </form>
            </div>
        </div>
        <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
</div>

